import { render, staticRenderFns } from "./CampaignMetrics.vue?vue&type=template&id=c4e2a1f4&scoped=true"
import script from "./CampaignMetrics.vue?vue&type=script&lang=js"
export * from "./CampaignMetrics.vue?vue&type=script&lang=js"
import style0 from "./CampaignMetrics.vue?vue&type=style&index=0&id=c4e2a1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e2a1f4",
  null
  
)

export default component.exports